import { createJSONRequest } from './create-request'
import querify from '../util/querify'

export const getExternalTaxonomyValuesByProperty = (parameters = {}) => createJSONRequest({
  method: 'GET',
  url: `/api/external/taxonomies/taxonomy-values-by-property?${querify(parameters)}`
});
